import { createSavingsPlan } from './createSavingsPlan'
import { updateSavingsPlan } from './updateSavingsPlan'
import { getSavingsPlanListVistaVendedor } from './getSavingsPlanListVistaVendedor'
import { getSavingsPlan } from './getSavingsPlan'
import { getPaginatedListSavingsPlan } from './getPaginatedListSavingsPlan'
import { getCounters } from './getCounters'
import { deleteSavingsPlan } from './deleteSavingsPlan'
import { getSpecsAndRelevantAttributes } from './getSpecsAndRelevantAttributes'
import { getSimilaritiesPlan } from './getSimilaritiesPlan'
import { getAllSavingsPlanSubscriptions } from './getAllSavingsPlanSubscriptions'
import { createSavingsPlanSubscription } from './createSavingsPlanSubscription'
import { getSavingsPlanSubscription } from './getSavingsPlanSubscription'
import { getSavingsPlanByLeadId } from './getSavingsPlanSubscriptionByLeadId'
import generatePDF from './generatePDF';
import sendEmail from './sendEmail'
import { postDmsIntegration } from './postDmsIntegration'

export const SavingsPlan = {
    createSavingsPlan,
    updateSavingsPlan,
    getSavingsPlanListVistaVendedor,
    getSavingsPlan,
    getPaginatedListSavingsPlan,
    getCounters,
    deleteSavingsPlan,
    getSpecsAndRelevantAttributes,
    getSimilaritiesPlan,
    getAllSavingsPlanSubscriptions,
    createSavingsPlanSubscription,
    getSavingsPlanSubscription,
    getSavingsPlanByLeadId,
    generatePDF,
    sendEmail,
    postDmsIntegration
}
